const JsonSafeInput = () => null;

export default JsonSafeInput;
